import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  pills?: React.ReactNode;
  /**
   * Optional help affordance (typically a <HelpPopover>). Renders
   * inline-right of the title so the trigger is discoverable next to
   * the page name without competing with subtitle copy.
   */
  help?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, pills, help }) => (
  <div className="gv-page-head">
    <div className="gv-page-title-row">
      <h1 className="gv-page-title">{title}</h1>
      {help && <span className="gv-page-help-slot">{help}</span>}
    </div>
    {subtitle && <p className="gv-page-sub">{subtitle}</p>}
    {pills && <div className="gv-page-pills">{pills}</div>}
  </div>
);

export default PageHeader;
